var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4866 3.60608L11.6333 4.27275L7.99997 6.97275L4.36663 4.24608L3.5133 3.57941C3.31227 3.41311 3.06687 3.30944 2.80749 3.28125C2.54812 3.25305 2.28617 3.30158 2.05411 3.4208C1.82204 3.54003 1.63005 3.72472 1.50193 3.952C1.3738 4.17927 1.31517 4.43914 1.3333 4.69941V12.4261C1.3333 12.6665 1.42882 12.8972 1.59886 13.0672C1.76889 13.2372 1.9995 13.3327 2.23997 13.3327H4.36663V8.18608L7.99997 10.9127L11.6333 8.18608V13.3327H13.76C14.0004 13.3327 14.231 13.2372 14.4011 13.0672C14.5711 12.8972 14.6666 12.6665 14.6666 12.4261V4.69941C14.6792 4.44139 14.6164 4.18528 14.4861 3.96223C14.3558 3.73917 14.1635 3.55878 13.9326 3.44297C13.7017 3.32716 13.4421 3.28092 13.1854 3.30988C12.9287 3.33883 12.6859 3.44174 12.4866 3.60608Z",
    fill: "#777778"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailAvatar);
export default __webpack_public_path__ + "static/media/mail-avatar.76cf549480f05d48fbc9c97d43f64f1f.svg";
export { ForwardRef as ReactComponent };